// extracted by mini-css-extract-plugin
module.exports = {"TextArea":"styles_TextArea__3J5XF","TextArea_Native":"styles_TextArea_Native__2uyFR"};